import React, { useEffect, useState } from 'react';
import Header from '../component/Header';
import Footer from '../component/Footer';
import axios from "../helper/axios";
export default function Returns() {

  const [allCms, setAllCms] = useState([]);

  const apiData = async () => {
    const res = await axios.post("/getcms");
    console.log(res?.status);
    console.log("----------Term res.data-----------", res.data)
    if (res.status === 200) {
      setAllCms(res?.data);
    } else {
      setAllCms()
    }
  }

  useEffect(() => {
    apiData();
  }, []);


  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0 });
  };

  useEffect(() => {
    scrollToTop();
  }, [])

  return (
    <>
      <Header />
      <div className='container mx-auto pt-32'>
        <div className="Cart mt-heading">
          <div className="p-0-mobile container wishlist">
            <div className="">
              <div className="CartItem fade-in-down">
                <div className="CartItem__content inner-pages delivery">
                  <h1 className="privacy-heading font-semibold text-2xl mb-4">
                    Politika e transportit të kthimit dhe rimbursimit në Albi Online
                  </h1>
                 

                  <p className="mb-4">
                    Për të garantuar një përvojë të këndshme blerjeje dhe transparencë të plotë ndaj klientëve tanë, Albi Online ka vendosur politikat e mëposhtme për transportin, kthimet, rimbursimet dhe pagesat.
                  </p>

                  <h2 className="font-semibold text-lg mt-6 mb-2">1. Politikat e transportit</h2>
                  <p className="mb-2">
                  Ne si Albi Online dëshirojmë të sigurojmë që përvoja juaj e blerjes të jetë e këndshme dhe pa vështirësi. Ju lutemi të lexoni politikën tonë të transportit.                  </p>

                  <h3 className="font-semibold mt-4 mb-1">Koha e Përpunimit:</h3>
                  <p className="mb-2">
                    Të gjitha porositë përpunohen brenda 7 ditëve të punës. Ne përpiqemi të dërgojmë porosinë tuaj sa më shpejt të jetë e mundur.
                  </p>

                  <h3 className="font-semibold mt-4 mb-1">Shtetet që transportohet:</h3>
                  <ul className="list-disc pl-6 mb-2">
                    <li>Transporti është i vlefshëm vetëm brenda territorit të Republikës së Kosovës.</li>
                  </ul>

                  <h3 className="font-semibold mt-4 mb-1">Tarifat e Transportit:</h3>
                  <ul className="list-disc pl-6 mb-2">
                    <li>Tarifa e transportit është 3€ për çdo porosi.</li>
                  </ul>

                  <h3 className="font-semibold mt-4 mb-1">Metodat e Transportit:</h3>
                  <p className="mb-2">
                    Metodat e transportit luajnë rol të rëndësishëm në sigurinë dhe efikasitetin e dërgesave. Në rastin tonë posta BEKI, përdorë një metodë efikase dhe të sigurt me ekipin e tyre duke u munduar të jenë sa më të saktë dhe korrekt me automjetet e tyre transportuese.
                  </p>

                  <h3 className="font-semibold mt-4 mb-1">Koha e pritshme e dorëzimit të produktit pas verifikimit:</h3>
                  <ul className="list-disc pl-6 mb-2">
                    <li>Koha e dorëzimit varet nga metoda e transportit dhe vendndodhja juaj. Koha e llogaritur e dorëzimit do të jetë deri në7 ditë, pas verifikimit të porosisë. Ju lutemi të keni parasysh se këto janë llogaritje, dhe koha e dorëzimit real mund të ndryshojë.</li>
                  </ul>

                  <h3 className="font-semibold mt-4 mb-1">Vonimet në Transport:</h3>
                  <ul className="list-disc pl-6 mb-2">
                    <li>Ndërsa përpilojmë kohët e pritshme të dorëzimit, rrethanat e papritura si vonimet postare, kushtet atmosferike ose faktorë të tjerë që janë jashtë kontrollit tonë mund të shkaktojnë vonime. Ju falënderojmë për mirëkuptimin në raste të tilla.</li>
                  </ul>

                  <h3 className="font-semibold mt-4 mb-1">Adresat e paplotësuara ose të pasakta:</h3>
                  <ul className="list-disc pl-6 mb-2">
                    <li>Është përgjegjësia e klientit të sigurojë informacionin e saktë dhe të plotë të transportit. Ju lutemi të kontrolloni dy herë adresën tuaj të transportit para se të përfundoni porosinë tuaj. Nëse ofrohet një adresë e pasaktë ose e paplotësuar, në rast se sjell kthimin e paketës te ne, mund të aplikohen tarifa shtesë transporti.</li>
                  </ul>

                  <h3 className="font-semibold mt-4 mb-1">Pakot e humbura ose të vjedhura:</h3>
                  <ul className="list-disc pl-6 mb-2">
                    <li>ALBI ONLINE nuk është përgjegjës për pakot e humbura ose të vjedhura. Ju lutemi të siguroheni që vendndodhja e dorëzimit është e sigurt, dhe mund të shtoni sigurim për dorëzimin për mbrojtje të shtuar.</li>
                  </ul>

                  <h3 className="font-semibold mt-4 mb-1">Informacioni për kontakt:</h3>
                  <ul className="list-disc pl-6 mb-4">
                    <li>Nëse keni ndonjë pyetje apo shqetësim në lidhje me transportin e porosisë suaj, ju lutemi të kontaktoni ekipin tonë të shërbimit ndaj klientit në <a href="mailto:support@albionline.com" className="underline">support@albionline.com</a> apo në telefonin 38348300800.</li>
                  </ul>

                  <h2 className="font-semibold text-lg mt-6 mb-2">2. Kthimet e produkteve</h2>
                  <ul className="list-disc pl-6 mb-4">
                    <li>Kthimet lejohen brenda 14 ditëve kalendarike nga data e pranimit të porosisë, në përputhje me praktikat më të mira të tregut dhe legjislacionin në fuqi.</li>
                    <li>Kjo periudhë mund të ndryshohet, kthimet janë vendim i Tregtarit.</li>
                    <li>Produkti duhet të jetë i papërdorur, me etiketat dhe paketimin origjinal, në të njëjtën gjendje që e keni marrë.</li>
                    <li>Kërkohet një kupon fiskal apo faturë ose vërtetim i blerjes për të gjitha kthimet nëse ka më shumë se një kthim.</li>
                    <li>Kthimi pranohet vetëm pasi produkti të arrijë fizikisht në magazinën tonë dhe të verifikohet nga ekipi ynë për gjendjen dhe përputhshmërinë.</li>
                  </ul>

                  <h2 className="font-semibold text-lg mt-6 mb-2">3. Kategoritë që nuk pranohen për kthim</h2>
                  <p className="mb-2">
                    Për arsye higjienike dhe ligjore, nuk pranohen kthime për produktet e mëposhtme:
                  </p>
                  <ul className="list-disc pl-6 mb-4">
                    <li>Artikuj të brendshëm (veshje intime, çorape, etj.)</li>
                    <li>Kozmetikë dhe produkte kujdesi personal</li>
                    <li>Produkte ushqimore</li>
                    <li>Produkte të personalizuara ose të porositura sipas specifikave tuaja</li>
                    <li>Produktet e përdorura dhe me paketime të dëmtuara.</li>
                  </ul>

                  <h2 className="font-semibold text-lg mt-6 mb-2">4. Procedura e kthimit</h2>
                  <ol className="list-decimal pl-6 mb-4 space-y-1">
                    <li>Klienti duhet të shkarkojë formularin e kthimit nga faqja jonë zyrtare <a href="https://www.albionline.com" className="underline" target="_blank" rel="noreferrer">www.albionline.com</a>.</li>
                    <li>Formulari duhet të plotësohet me:
                      <ul className="list-disc pl-6 mt-1">
                        <li>Të dhënat personale,</li>
                        <li>Numrin e porosisë,</li>
                        <li>Arsyen e kthimit,</li>
                        <li>Numrin e xhirollogarisë bankare, nëse porosia është paguar me para të gatshme (cash).</li>
                      </ul>
                    </li>
                    <li>Pasi produkti të arrijë fizikisht tek ne, ekipi ynë do ta shqyrtojë kërkesën dhe do njoftojë klientin me e-mail për pranimin ose refuzimin e kthimit.</li>
                  </ol>

                  <h2 className="font-semibold text-lg mt-6 mb-2">5. Politika e pagesave, afati dhe mënyra e rimbursimit</h2>
                  <ul className="list-disc pl-6 mb-4">
                    <li>Pagesat kryhen me para të gatshme (cash) apo online, përmes kartelave bankare të pranuara nga sistemi ynë.</li>
                    <li>Pasi të pranohet dhe verifikohet produkti, rimbursimi realizohet brenda 14 ditëve pune.</li>
                    <li>Rimbursimet kryhen vetëm përmes xhirollogarisë bankare të shënuar në formularin e kthimit.</li>
                    <li>Rimbursimet realizohen vetëm në të njëjtën llogari bankare nga e cila është kryer pagesa e porosisë. Përjashtimisht, në rastet kur pagesa është bërë me para të gatshme (cash), rimbursimi do të bëhet në llogarinë bankare të deklaruar në formularin e kthimit.</li>
                  </ul>

                  <h2 className="font-semibold text-lg mt-6 mb-2">6. Kostoja e transportit</h2>
                  <ul className="list-disc pl-6 mb-4">
                    <li>Në rastet kur kthimi bëhet për arsye personale (p.sh. madhësia, ngjyra apo mospëlqimi), koston e transportit e mbulon klienti, në momentin e kthimit të porosisë.</li>
                    <li>Nëse produkti është i gabuar ose i dëmtuar nga ana e shitësit, transporti mbulohet nga Albi Online.</li>
                  </ul>

                  <h2 className="font-semibold text-lg mt-6 mb-2">7. Procesi i anulimit të porosisë</h2>
                  <ul className="list-disc pl-6 mb-4">
                    <li>Procesi i anulimit të porosisë fillon me plotësimin of formularit online, i cili gjendet në seksionin “Porositë e mia” brenda llogarisë së klientit.</li>
                    <li>Brenda këtij seksioni, klienti duhet të zgjedhë:
                      <ul className="list-disc pl-6 mt-1">
                        <li>“Rishikimin e porosisë”,</li>
                        <li>Opsionin “KTHIMI” (butoni i zi),</li>
                        <li>Artikullin që dëshiron të kthejë,</li>
                        <li>Plotësimin e të gjitha fushave të detyrueshme me radhë.</li>
                      </ul>
                    </li>
                    <li>Në faqen “Porositë e mia” mund të hyhet gjithashtu edhe përmes opsionit të dedikuar në website.</li>
                  </ul>

                  <h2 className="font-semibold text-lg mt-6 mb-2">8. Kontakt dhe mbështetje</h2>
                  <p className="mb-2">
                    Për çdo kërkesë që lidhet me kthime, anulime ose ankesa, klientët mund të kontaktojnë ekipin tonë të mbështetjes:
                  </p>
                  <ul className="list-disc pl-6 mb-4">
                    <li>📧 <a href="mailto:support@albionline.com" className="underline">support@albionline.com</a></li>
                    <li>⏰ Brenda 48 orëve nga marrja e produktit.</li>
                  </ul>

                  <p className="mt-4 text-sm text-gray-700">
                    Vërejtje: Albi Online rezervon të drejtën të refuzojë kthimin ose rimbursimin e një produkti nëse nuk plotësohen kushtet e përcaktuara në këtë politikë.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

